import React from "react";

import {
    ContentListContainerProps,
    ContentListContainerState
} from "./models";

import {
    Box,
    CircularProgress,
    Typography
} from "@mui/material";

import "./style.css";
import { ContentEnduserService } from "services/content-enduser-service";
import { Trans } from "@lingui/macro";
import { ContentListCarousel } from "components/home/content-list-carousel/content-list-carousel"

export class ContentListContainer extends React.Component<ContentListContainerProps, ContentListContainerState> {

    constructor(props: Readonly<ContentListContainerProps> | ContentListContainerProps) {
        super(props);

        this.state = {
            contentListArray: null,
            loadedWithError: false,
            loaded: false
        };
    }

    componentDidMount() {
        ContentEnduserService.getContentListWithContent(this.getContentListWithContentsCallback, this.errorCallback);
    }

    getContentListWithContentsCallback = (data: any) => {
        this.setState(() => ({ contentListArray: data.list, loaded: true }))
    }

    errorCallback = (err: any) => {
        console.log(err)
        this.setState(() => ({ loaded: true, loadedWithError: true }))
    }

    render() {
        return (<>
            {(this.state.loaded && !this.state.loadedWithError)}
            {this.state.contentListArray !== null && <Box sx={{mb: 28}}>
                <ContentListCarousel contentLists={this.state.contentListArray} />
            </Box>}
            {!this.state.loaded && <Box sx={{
                display: "flex",
                justifyContent: "center",
                p: 6,
                width: "100%"
            }}>
                <CircularProgress color="secondary" />
            </Box>}
            {this.state.loadedWithError && <Box sx={{
                display: "flex",
                justifyContent: "center",
                p: 6,
                width: "100%"
            }}>
                <Typography variant={"h6"} color={"red"}>
                    <Trans id={"clc-error"}> Si è verificato un errore nell'ottenimento del catalogo</Trans>
                </Typography>
            </Box>}
        </>);
    }
}
